/**
 * Wedding Books — section shell.
 *
 * Its own <Routes> mounted at /dashboard/wedding/*, following
 * components/quill/QuillSection.tsx — MINUS the health provider. Quill needs
 * one because it proxies to a separate backend that is routinely not running;
 * this section reads the same Aurora database through the same admin-backend
 * that served the page, so there is nothing extra to probe. A failed request is
 * a per-card EmptyState with Retry instead.
 *
 * ROUTE SLUGS ARE LOAD-BEARING. __e2e__/navigation.journey.test.tsx reads the
 * <Route path="..."> literals out of this file and the /dashboard/wedding/*
 * paths out of Sidebar.tsx and asserts the two sets are identical, so a nav
 * entry can never point at a slug with no route (or vice versa). Keep them as
 * plain string literals. `books/:bookId` is deliberately excluded by that
 * test's [a-z-]+ pattern — it is reached from a row click, not the rail.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WeddingOverviewPage from './overview/WeddingOverviewPage';
import WeddingBooksPage from './books/WeddingBooksPage';
import BookDetailPage from './books/BookDetailPage';
import WeddingRevenuePage from './revenue/WeddingRevenuePage';
import WeddingCouplesPage from './couples/WeddingCouplesPage';
import WeddingConversionsPage from './conversions/WeddingConversionsPage';
import WeddingCataloguePage from './catalogue/WeddingCataloguePage';
import WeddingTemplatesPage from './templates/WeddingTemplatesPage';
import WeddingMembersPage from './members/WeddingMembersPage';
import WeddingClaimsPage from './revenue/WeddingClaimsPage';
import WeddingModerationPage from './moderation/WeddingModerationPage';

export const WeddingSection: React.FC = () => (
  <Routes>
    <Route path="/" element={<Navigate to="overview" replace />} />
    <Route path="overview" element={<WeddingOverviewPage />} />
    <Route path="books" element={<WeddingBooksPage />} />
    <Route path="books/:bookId" element={<BookDetailPage />} />
    <Route path="revenue" element={<WeddingRevenuePage />} />
    {/*
      NESTED, AND THEREFORE INVISIBLE TO THE RAIL BY CONSTRUCTION. The journey
      test's route regex is [a-z-]+, which a path containing a slash cannot
      match, so this drill-down needs no Sidebar entry and the rail stays the
      length the design fixed. It is reached from the Revenue page's claims
      card, exactly as books/:bookId is reached from a row.
    */}
    <Route path="revenue/claims" element={<WeddingClaimsPage />} />
    <Route path="couples" element={<WeddingCouplesPage />} />
    <Route path="conversions" element={<WeddingConversionsPage />} />
    <Route path="catalogue" element={<WeddingCataloguePage />} />
    <Route path="templates" element={<WeddingTemplatesPage />} />
    <Route path="members" element={<WeddingMembersPage />} />
    <Route path="moderation" element={<WeddingModerationPage />} />
  </Routes>
);

export default WeddingSection;
